<template>
  <button
    class="AiSingleCarouselButton"
    role="button"
    :aria-label="
      props.direction === 'left'
        ? $t('ux.molecules.carousel.previousSlide')
        : $t('ux.molecules.carousel.nextSlide')
    "
    @click="$emit('click')">
    <ai-icon
      class="AiSingleCarouselButton-icon"
      :name="icon"
      :size="12"
      color="white" />
  </button>
</template>

<script setup lang="ts">
import AiIcon from '../AiIcon/AiIcon.vue';

type Props = {
  direction?: 'left' | 'right';
};

type Emits = {
  (event: 'click'): void;
};

defineEmits<Emits>();
const props = withDefaults(defineProps<Props>(), {
  direction: 'left',
});

const icon = computed<'chevron-left' | 'chevron-right'>(
  () => `chevron-${props.direction}`,
);
</script>

<style scoped lang="scss">
@use '@/assets/styles/utilities/colors';
@use '@/assets/styles/utilities/constants';
@use '@/assets/styles/utilities/functions' as func;

.AiSingleCarouselButton {
  display: inline-block;
  box-sizing: border-box;
  height: func.calcRem(32);
  width: func.calcRem(32);
  line-height: func.calcRem(24);
  text-align: center;
  padding: constants.$inner-01;
  background-color: colors.$neutral-900;
  border-radius: 50%;
  border: 1px solid colors.$white;
}

.AiSingleCarouselButton-icon {
  color: colors.$white;
}
</style>
